import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2686b77f"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2686b77f')) {
      api.createRecord('2686b77f', component.options)
    } else {
      api.reload('2686b77f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2686b77f", function () {
      api.rerender('2686b77f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/logs/detail.vue"
export default component.exports